<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="8" offset="14">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="素材标题">
                            <el-input v-model="formInline.mediaTitle" placeholder="素材标题"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="getList">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip class="item" effect="dark" content="新增" placement="right">
                                <el-button type="success" size="mini" @click="handleAdd">新增</el-button>
                            </el-tooltip>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="mediaId" label="标识" width="120"></el-table-column>
            <el-table-column prop="mediaTitle" label="素材标题" width="120"></el-table-column>
            <!--<el-table-column prop="basePath" label="素材路径" width="150"></el-table-column>-->
            <!--<el-table-column prop="pathTypeName" label="连接类型"></el-table-column>-->
            <el-table-column prop="itemDesc" label="类型名称">
                <template slot-scope="scope">
                    {{scope.row.itemDesc+scope.row.pathTypeName}}
                </template>
            </el-table-column>
            <el-table-column prop="picUrl" label="图片" width="120">
                <template slot-scope="scope">
                    <img :src="scope.row.picUrl" width="70" height="70"/>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建日期" width="150"></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="success" v-show="false" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                    <el-tooltip class="item" effect="dark" content="点这里去配置分销员素材" placement="top-end">
                        <el-button type="success" size="mini" @click="configStaff(scope.row)">分销员素材</el-button>
                    </el-tooltip>
                    <el-button type="warning" size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.mediaId></el-input>
                </el-form-item>
                <el-form-item label="createTime" :hidden="true">
                    <el-input v-model=form.createTime></el-input>
                </el-form-item>
                <el-form-item label="素材标题" :required="true">
                    <el-input type="text" v-model=form.mediaTitle clearable placeholder="页面标题" maxlength="40"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="页面类型" :required="true">
                    <el-select v-model="form.pathType" placeholder="页面类型">
                        <el-option v-for="item in pathTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="请选择促销" v-show="form.pathType==1" :required="true">
                    <el-select v-model="form.itemId" placeholder="促销"
                               filterable
                               clearable
                               remote
                               :remote-method="getPromotionList"
                               @change="promotionChange"
                               >
                        <el-option v-for="item in promotionListData"
                                   :key="item.promotionId"
                                   :label="item.promotionName"
                                   :value="item.promotionId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择套装" v-show="false" :required="true">
                    <el-select v-model="form.itemId" placeholder="套装">
                        <el-option v-for="item in promotionListData"
                                   :key="item.promotionId"
                                   :label="item.promotionName"
                                   :value="item.promotionId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择单品" v-show="form.pathType==4" :required="true">
                    <el-select v-model="form.itemId" placeholder="单品"
                               filterable
                               clearable
                               remote
                               :remote-method="getProductList"
                               @change="productChange">
                        <el-option v-for="item in productList"
                                   :key="item.proId"
                                   :label="item.proName"
                                   :value="item.proId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择活动" v-show="form.pathType==5" :required="true">
                    <el-select v-model="form.itemId"
                               filterable
                               clearable
                               remote
                               :remote-method="initActiveList"
                               @change="activeChange"
                               placeholder="输入活动名称查询">
                        <el-option v-for="item in activeList"
                                   :key="item.bindCode"
                                   :label="item.activeName"
                                   :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="素材路径">-->
                    <!--<el-input type="text" v-model=form.basePath clearable placeholder="素材路径" maxlength="255"-->
                              <!--show-word-limit></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="素材图片">
                    <el-button @click="selectUpload">上传图片</el-button>
                    <el-image
                            class="select-pic"
                            style="width: 100px; max-height: 200px"
                            :src="selectImageUrl"
                            :preview-src-list="[selectImageUrl]">
                    </el-image>
                </el-form-item>
                <el-form-item>
                    <el-button-group>
                        <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                        <el-button size="mini" type="primary" @click="save(form)">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
        <picDialog :picType="activeNo" :fromState="'onlyOne'" @selectPicOne="selectPicOne"></picDialog>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getDistributionMediaList,
        getDistributionMediaStaffList,
        saveDistributionMedia,
        saveDistributionStaffMedia,
        getActiveList,
        getProductList,
        deleteZhichiMedia,
        promotionList
    } from '../../api/api';
    import uploadComponents from '@/components/upload';
    import picDialog from '@/components/pic_dialog/pic_list'
    import Preview from "../../components/Preview";
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                defaultConfigData: [{"id": 0, "name": "否"}, {"id": 1, "name": "是"}],
                loading: true,
                dialogFormVisible: false,
                showPreviewDialog: false,
                pathTypeList: [{"id": 0, "name": "商城首页"}, {"id": 1, "name": "促销"}, {"id": 5, "name": "活动"}, {
                    "id": 4,
                    "name": "单品"
                }, {"id": 11, "name": "储值"}],
                form: {
                    mediaId: '',
                    mediaTitle: '',
                    basePath: 'pages/home/index',
                    appId: '',
                    distributorRelationId: 0,
                    pathType: 0,
                    itemId: '',
                    picUrl: '',
                    createTime: ''
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    mediaTitle: '' || this.$route.query.mediaTitle,
                },
                platformDisabled: false,
                activeList: [],
                activeForm: {
                    activeName: "",
                    activeType: '',
                    currentPage: 1,
                    pageSize: 20,
                    status: 1
                },
                productForm: {
                    proName: "",
                    currentPage: 1,
                    recordsTotal: 0,
                    pageSize: 20,
                },
                promotionForm: {
                    promotionName: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                promotionListData: [],
                activeNo: '',
                selectImageUrl: ''
            }
        },
        computed: {
            productList: function () {
                return this.$store.getters.getPro.list
            },
            totalRecord: function () {
                return this.$store.getters.getPro.total
            },
            productTypes: function () {
                return this.$store.getters.getProductType
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        components: {
            uploadComponents, picDialog
        },
        methods: {
            //定义查询方法
            getList(){
                getDistributionMediaList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if (confirm("删除:" + row.mediaTitle + "会连同分销员素材一起删除,确定删除:" + row.mediaTitle + "吗？")) {
                    deleteZhichiMedia({mediaId: row.mediaId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form = {
                    mediaId: '',
                    mediaTitle: '',
                    basePath: '',
                    appId: 'wxccfc57d73bc81766',
                    pathType: 0,
                    itemId: '',
                    picUrl: '',
                    createTime: ''
                }
            },
            handlePreActive(row){
                if (row.pathType ==5) {
                    this.params = {bindCode: row.bindCode, activeNo: row.activeNo};
                } else {
                    this.params = {productId: row.itemId, productType: row.pathType};
                }
                this.showPreviewDialog = true;
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.form = {
                    mediaId: data.mediaId,
                    mediaTitle: data.mediaTitle,
                    basePath: data.basePath,
                    appId: data.appId,
                    pathType: data.pathType,
                    itemId: data.itemId,
                    picUrl:  data.picUrl,
                    createTime: data.createTime
                }
                this.selectImageUrl=this.form.picUrl;
            },
            save(data){
                console.log(data);
                if (data.mediaTitle == "") {
                    this.$message({
                        message: "请输入页面标题",
                        type: 'error'
                    });
                    return;
                }
                if (data.picUrl == "") {
                    this.$message({
                        message: "请选择素材图片",
                        type: 'error'
                    });
                    return;
                }
                saveDistributionMedia(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            initActiveList(activeName){
                this.activeForm.activeName = activeName;
                this.activeList = [];
                getActiveList(this.activeForm).then((res) => {
                    console.log(res.data.value.list)
                    this.activeList = res.data.value.list;
                })
            },
            configStaff(row){
                this.$router.push({path: '/mediaStaff', query: {mediaId: row.mediaId, mediaTitle:row.mediaTitle}})
            },
            getProductList(proName){
                this.loading = true;
                this.productForm.proName = proName;
                let _this = this;
                this.$store.dispatch('initProList', this.productForm).then(function (res) {
                    _this.loading = false;
                })
            },
            getPromotionList(proName){
                this.promotionForm.promotionName = proName;
                promotionList(this.promotionForm).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.promotionListData = res.data.list;
                })
            },
            returnHistory(){
                window.history.back()
            },
            selectUpload(){
                this.$store.commit('SET_PIC_DIALOG', true)
            },
            selectPicOne(obj){
                console.log(obj)
                this.$store.commit('SET_PIC_DIALOG', false)
                this.form.picUrl = obj.imagePath
                this.selectImageUrl = obj.allImagePath
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/distribution/media.vue